module.exports = __webpack_public_path__ + "static/3-8a0e28f1aae0904be39a6598ac8e010a.png";